import { render, staticRenderFns } from "./FastFlame.vue?vue&type=template&id=66282ceb&"
import script from "./FastFlame.vue?vue&type=script&lang=js&"
export * from "./FastFlame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports